import api from "utils/api";

// Get all transactions with filters and pagination
export const getAllTransactions = async (params = {}) => {
  try {
    const response = await api.get("/transactions", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Create a new transaction
export const createTransaction = async (data) => {
  try {
    const response = await api.post("/transactions", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
